import { createContext, useContext, useRef, ReactNode } from "react";
import { FormState, useFormState } from "@/components/store/useFormState";
import { useStore, StoreApi } from "zustand";
import { FormData, useFormData } from "@/components/store/useFormData";

interface FormStores {
	formDataStore: StoreApi<FormData>;
	formStateStore: StoreApi<FormState>;
}

// Create context for the scoped store
export const FormStoresContext = createContext<FormStores | null>(null);

// Context provider component
export const FormContextProvider = ({ id, children }: { id: HTMLElement; children: ReactNode }) => {
	const formDataStoreRef = useRef(useFormData());
	const formStateStoreRef = useRef(useFormState());

	return (
		<FormStoresContext.Provider
			value={{
				formDataStore: formDataStoreRef.current,
				formStateStore: formStateStoreRef.current,
			}}
		>
			{children}
		</FormStoresContext.Provider>
	);
};

// Hook to consume the scoped store
export const useFormDataStore = () => {
	const store = useContext(FormStoresContext);
	if (!store) throw new Error("useFormDataStore must be used inside FormDataProvider");
	return useStore(store.formDataStore);
};

export const useFormStateStore = () => {
	const store = useContext(FormStoresContext);
	if (!store) throw new Error("useFormStateStore must be used inside FormStateProvider");
	return useStore(store.formStateStore);
};
